/* tslint:disable */
/* eslint-disable */
/**
 * Appli métier
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: Yoda 1 & 2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration"
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios"
import globalAxios from "axios"
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded
} from "../common"
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap
} from "../base"
// @ts-ignore
import type { ApiBenchMark } from "../model"
// @ts-ignore
import type { SaveBenchMarkRequest } from "../model"
/**
 * BenchMarkResourceV2Api - axios parameter creator
 */
export const BenchMarkResourceV2ApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Delete benchmark
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteBenchMark: async (
      noteId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'noteId' is not null or undefined
      assertParamExists("deleteBenchMark", "noteId", noteId)
      const localVarPath = `/v2.0/benchMark/{noteId}`.replace(
        "{noteId}",
        encodeURIComponent(String(noteId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Get benchmark by note id
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBenchMark: async (
      noteId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'noteId' is not null or undefined
      assertParamExists("getBenchMark", "noteId", noteId)
      const localVarPath = `/v2.0/benchMark/{noteId}`.replace(
        "{noteId}",
        encodeURIComponent(String(noteId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Update benchmark
     * @param {SaveBenchMarkRequest} saveBenchMarkRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateBenchMark: async (
      saveBenchMarkRequest: SaveBenchMarkRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'saveBenchMarkRequest' is not null or undefined
      assertParamExists("updateBenchMark", "saveBenchMarkRequest", saveBenchMarkRequest)
      const localVarPath = `/v2.0/benchMark`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        saveBenchMarkRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * BenchMarkResourceV2Api - functional programming interface
 */
export const BenchMarkResourceV2ApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = BenchMarkResourceV2ApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Delete benchmark
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteBenchMark(
      noteId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBenchMark(noteId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["BenchMarkResourceV2Api.deleteBenchMark"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get benchmark by note id
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getBenchMark(
      noteId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiBenchMark>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getBenchMark(noteId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["BenchMarkResourceV2Api.getBenchMark"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Update benchmark
     * @param {SaveBenchMarkRequest} saveBenchMarkRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateBenchMark(
      saveBenchMarkRequest: SaveBenchMarkRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiBenchMark>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateBenchMark(
        saveBenchMarkRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["BenchMarkResourceV2Api.updateBenchMark"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * BenchMarkResourceV2Api - factory interface
 */
export const BenchMarkResourceV2ApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = BenchMarkResourceV2ApiFp(configuration)
  return {
    /**
     *
     * @summary Delete benchmark
     * @param {BenchMarkResourceV2ApiDeleteBenchMarkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteBenchMark(
      requestParameters: BenchMarkResourceV2ApiDeleteBenchMarkRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<boolean> {
      return localVarFp
        .deleteBenchMark(requestParameters.noteId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Get benchmark by note id
     * @param {BenchMarkResourceV2ApiGetBenchMarkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBenchMark(
      requestParameters: BenchMarkResourceV2ApiGetBenchMarkRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ApiBenchMark> {
      return localVarFp
        .getBenchMark(requestParameters.noteId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Update benchmark
     * @param {BenchMarkResourceV2ApiUpdateBenchMarkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateBenchMark(
      requestParameters: BenchMarkResourceV2ApiUpdateBenchMarkRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ApiBenchMark> {
      return localVarFp
        .updateBenchMark(requestParameters.saveBenchMarkRequest, options)
        .then(request => request(axios, basePath))
    }
  }
}

/**
 * Request parameters for deleteBenchMark operation in BenchMarkResourceV2Api.
 */
export interface BenchMarkResourceV2ApiDeleteBenchMarkRequest {
  readonly noteId: string
}

/**
 * Request parameters for getBenchMark operation in BenchMarkResourceV2Api.
 */
export interface BenchMarkResourceV2ApiGetBenchMarkRequest {
  readonly noteId: string
}

/**
 * Request parameters for updateBenchMark operation in BenchMarkResourceV2Api.
 */
export interface BenchMarkResourceV2ApiUpdateBenchMarkRequest {
  readonly saveBenchMarkRequest: SaveBenchMarkRequest
}

/**
 * BenchMarkResourceV2Api - object-oriented interface
 */
export class BenchMarkResourceV2Api extends BaseAPI {
  /**
   *
   * @summary Delete benchmark
   * @param {BenchMarkResourceV2ApiDeleteBenchMarkRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public deleteBenchMark(
    requestParameters: BenchMarkResourceV2ApiDeleteBenchMarkRequest,
    options?: RawAxiosRequestConfig
  ) {
    return BenchMarkResourceV2ApiFp(this.configuration)
      .deleteBenchMark(requestParameters.noteId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get benchmark by note id
   * @param {BenchMarkResourceV2ApiGetBenchMarkRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getBenchMark(
    requestParameters: BenchMarkResourceV2ApiGetBenchMarkRequest,
    options?: RawAxiosRequestConfig
  ) {
    return BenchMarkResourceV2ApiFp(this.configuration)
      .getBenchMark(requestParameters.noteId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Update benchmark
   * @param {BenchMarkResourceV2ApiUpdateBenchMarkRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public updateBenchMark(
    requestParameters: BenchMarkResourceV2ApiUpdateBenchMarkRequest,
    options?: RawAxiosRequestConfig
  ) {
    return BenchMarkResourceV2ApiFp(this.configuration)
      .updateBenchMark(requestParameters.saveBenchMarkRequest, options)
      .then(request => request(this.axios, this.basePath))
  }
}
